import styled from 'styled-components';
import IconInfo from 'assets/icon/ic_info.svg';
const Frame = styled.div`
  width: 100%;
  height: 100%;

  .jobflex-logo{
    position: fixed;
    top: 0;
    left: 0;
    margin:30px;
    }

    .frame-footer {
     position:absolute;
     bottom:0;
  }

  .jobview-info-frame{
    position: fixed;
    top: 0;
    right:0;
    margin:30px;
    display:flex;
    flex-direction:row;
    align-items:center;
    justify-content:space-between;

    .user-frame{
      background: #1E2F4E 0% 0% no-repeat padding-box;
      border-radius: 27px;
      opacity: 1;
      padding: 10px 24px;
      font-size:14px;
      line-height:22px;
      color: #FFFFFF;
    }
    .guide-btn{
      background: #1E2F4E 0% 0% no-repeat padding-box;
      border-radius: 2px;
      opacity: 1;
      width: 54px;
      height: 54px;
      margin-left:10px;
      background-position:center center;
      background-image:url(${IconInfo});
    }
  }

`;

export default Frame;
export {Frame};